import { useState } from 'react';
import * as XLSX from 'xlsx';

export const useExcelExport = () => {
  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async (data, filename) => {
    try {
      setIsExporting(true);

      // Map English keys to Arabic headers
      const arabicHeaders = {
        orderCode: 'رقم الطلب',
        workDescription: 'وصف العمل',
        district: 'المنطقة',
        contractor: 'المقاول',
        consultant: 'المستشار',
        office: 'المكتب',
        situation: 'الحالة',
        createAt: 'تاريخ البدء',
        completionDate: 'تاريخ الانتهاء',
        durationOfImplementation: 'مدة التنفيذ',
        estimatedValue: 'القيمة المقدرة',
        projectType: 'نوع المشروع',
        // Add more mappings as needed
      };

      // Transform data to use Arabic headers
      const arabicData = data.map(item => {
        const transformedItem = {};
        Object.keys(item).forEach(key => {
          // Use Arabic header if available, otherwise keep original key
          const arabicKey = arabicHeaders[key] || key;
          
          // Format special fields
          let value = item[key];
          
          // Format dates
          if (key === 'createAt' || key === 'completionDate') {
            if (value) {
              const date = new Date(value);
              value = date.toLocaleDateString('ar-SA');
            } else {
              value = '-';
            }
          }
          
          // Format duration
          if (key === 'durationOfImplementation' && value) {
            value = `${value} يوم`;
          }
          
          // Format estimated value
          if (key === 'estimatedValue' && value) {
            value = `${value} ريال`;
          }
          
          // Format project type
          if (key === 'projectType') {
            const projectTypes = {
              rehabilitationWorks: 'أعمال إعادة التأهيل',
              constructionProjects: 'مشاريع البناء',
              emergencyProjects: 'المشاريع الطارئة',
              maintainProjects: 'مشاريع الصيانة'
            };
            value = projectTypes[value] || value;
          }
          
          // Format situation
          if (key === 'situation') {
            const situations = {
              'قيد التنفيذ': 'قيد التنفيذ',
              'تم التنفيذ': 'تم التنفيذ',
              'معلق': 'معلق',
              'ملغي': 'ملغي',
              'لا يحتاج تصريح': 'لا يحتاج تصريح'
            };
            value = situations[value] || value;
          }
          
          transformedItem[arabicKey] = value;
        });
        return transformedItem;
      });

      // Convert data to worksheet
      const ws = XLSX.utils.json_to_sheet(arabicData);

      // Set column widths for better readability
      const colWidths = [
        { wch: 15 }, // رقم الطلب
        { wch: 40 }, // وصف العمل
        { wch: 20 }, // المنطقة
        { wch: 25 }, // المقاول
        { wch: 25 }, // المستشار
        { wch: 20 }, // المكتب
        { wch: 15 }, // الحالة
        { wch: 15 }, // تاريخ البدء
        { wch: 15 }, // تاريخ الانتهاء
        { wch: 15 }, // مدة التنفيذ
        { wch: 15 }, // القيمة المقدرة
        { wch: 20 }, // نوع المشروع
      ];
      ws['!cols'] = colWidths;

      // Create workbook and append worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'بيانات المشاريع');

      // Save to file
      XLSX.writeFile(wb, filename);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportToExcel, isExporting };
};

export default useExcelExport; 